import '../scss/main.scss';
import $ from "jquery";
import 'bootstrap';
import Swiper from 'swiper';
import Sticky from 'sticky-js';
import * as AOS from 'aos';
import 'aos/dist/aos.css';


import {disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks} from 'body-scroll-lock';


const FondationCancerGeneral = {
    "mqBreakpoints": {
        xs: 0,
        sm: 576,
        md: 810,
        lg: 992,
        xl: 1156
    },

    "preventScrollOpenedMenu": function () {
        const targetElement = document.querySelector('.navbar__content');
        const targetElement2 = document.querySelector('.navbar-main__dropdown__content');
        if ($(window).width() < this.mqBreakpoints.xl) {
            $('header .navbar-collapse').on('show.bs.collapse', function () {
                // disableBodyScroll(targetElement);
                $('html').addClass('menu-open');
            })
            $('header .navbar-collapse').on('hide.bs.collapse', function () {
                // enableBodyScroll(targetElement);
                $('html').removeClass('menu-open');
            })
        } else {
            // enableBodyScroll(targetElement);
            // clearAllBodyScrollLocks();
            $('html').removeClass('menu-open');
        }
    },

    "mobileMenuAlert": function () {
        let self = this;
        if ($('.navbar-main').length && $('.js-alert').length && !$('.js-alert.closed').length) {
            if ($(window).width() < this.mqBreakpoints.lg) {
                let alertHeight = $('.js-alert').outerHeight();

                $('.offcanvas-collapse').css('top', alertHeight);
                $('.navbar-main__collapse-top').css('top', alertHeight + 10);
                $('.navbar-main__dropdown').css({'top': alertHeight + 136, 'height': $(window).height() - alertHeight});

                $('.navbar-main').on('show.bs.collapse', function () {
                    $('header').css({"bottom": 0});
                    $('.navbar-main').css({'background-color': '#FFF'});
                })
                $('.navbar-main').on('hide.bs.collapse', function () {
                    $('header').css({"bottom": "auto", "overflow-y": "auto"});
                    if ($(window).width() < self.mqBreakpoints.lg) {
                        $('.secondary-menu-container').css({"maxHeight": "auto", "maxHeight": 300});
                    } else {
                        $('.secondary-menu-container').css({"maxHeight": "auto"});
                    }
                    $('.navbar-main').css({'background-color': 'transparent'});
                })

                $('.nav-item.expanded').on('show.bs.dropdown', function () {
                    $('.offcanvas-collapse').css({"overflow-y": 'hidden'});
                })
                $('.nav-link-expand').on('hide.bs.dropdown', function () {
                    $('.offcanvas-collapse').css({"overflow-y": 'auto'});
                })
            }
        } else {
            $('.offcanvas-collapse').css('top', 0);
            $('.navbar-main__collapse-top').css('top', 10);
            $('.navbar-main__dropdown').css({'height': $(window).height()});
            $('.navbar-main').css({'background-color': 'transparent'});
        }
    },


    "closeMenuOnResize": function () {
        if ($('#navbar-main').length) {
            if ($(window).width() > this.mqBreakpoints.lg) {
                $('#navbar-main').collapse('hide');
                $('.dropdown').dropdown('hide');
            }
        }
    },

    "addClassOnOpenedMenu": function () {
        if ($('.js-main-nav-container').length) {
            $(document).on('click', '.js-full-width-dropdown.dropdown-menu', function (e) {
                e.stopPropagation();
            });
            if ($(window).width() <= this.mqBreakpoints.lg) {
                var scroll = $(window).scrollTop();

                $('.navbar-main').on('show.bs.collapse', function () {
                    $(this).addClass('menu-open');
                    $('.js-logo-menu-open').removeClass('d-none');

                    if (scroll >= 20) {
                        $(".js-active-class-onscroll").removeClass("active");
                    }
                }).on('hidden.bs.collapse', function () {
                    $(this).removeClass('menu-open');
                    $('.js-logo-menu-open').addClass('d-none');

                    if (scroll >= 20) {
                        $(".js-active-class-onscroll").addClass("active");
                    }
                })
            } else {
                $('.js-logo-menu-open').addClass('d-none');
            }
        }
    },


    "addActiveClassOnScroll": function () {
        if ($('.js-active-class-onscroll').length) {
            var addClass = function () {
                var scroll = $(window).scrollTop();
                if (scroll >= 10) {
                    $(".js-active-class-onscroll").addClass("active");
                } else {
                    $(".js-active-class-onscroll").removeClass("active");
                }
            }
            addClass();
            $(window).scroll(function () {
                addClass();
            });

            var changeColorOnScroll = function () {
                var scroll = $(window).scrollTop();
                if (scroll >= 10) {
                    $('header').css('background-color', 'white');
                } else {
                    $('header').css('background-color', 'transparent');
                }
            };

            if ($(window).innerWidth() < FondationCancerGeneral.mqBreakpoints[$('header').find("[class*='navbar-expand-']").attr('class').match(/navbar-expand-([a-z]{2})/)[1]]) {
                changeColorOnScroll()
                $(window).scroll(function () {
                    changeColorOnScroll();
                });
            }


        }
    },

    "setSameHeight": function () {
        if ($('.js-same-height-container').length) {
            var setHeight = function () {
                var maxHeight = 0;
                $('.js-same-height-container').each(function () {
                    var elements = $(this).find('.js-same-height');
                    var elementsMax = $(this).find('.js-same-height-max');
                    elements.each(function () {
                        if ($(this).outerHeight() > maxHeight) {
                            maxHeight = $(this).outerHeight();
                        }
                    });
                    elements.css('height', maxHeight);
                    if ($('.js-same-height-max').length) {
                        elementsMax.css('max-height', maxHeight, true);
                    }
                });
            };

            if ($('.js-same-height-container').hasClass('-tablet')) {
                if ($(window).width() >= this.mqBreakpoints.md) {
                    setHeight();
                }
            } else {
                setHeight();
            }

        }
    },


    "setPaddingTop": function (alertHeight) {
        if ($('.js-set-padding-top').length && $('header').length) {
            var scroll = $(window).scrollTop();
            let root = document.documentElement,
                headerOffset = 20,
                headerHeight;
            if ($('.menu-open').length && $(window).width() < this.mqBreakpoints.lg) {
                headerHeight = $('.navbar-header').outerHeight();
            } else {
                headerHeight = $('header').outerHeight();
            }

            if (alertHeight) {
                headerHeight = headerHeight - alertHeight;
            }

            if ($(window).width() >= this.mqBreakpoints.lg) {
                headerOffset = 10;
                if (headerHeight < 132) {
                    headerHeight = 132;
                }
            }
            if (headerHeight + headerOffset < 100) {
                root.style.setProperty('--header-height', "100px");
            } else {
                root.style.setProperty('--header-height', headerHeight + headerOffset + "px");
            }
        }
    },

    "fixDropdownLinks": function () {
        //on mobile: clic on those links should toggle dropdown
        //on desktop: go to the page
        if ($('.dropdown-hover-container').length) {
            var goToPage = function () {
                var links = $('.dropdown-hover-container').find('.nav-link-expand');
                var subnavLinks = $('.navbar-main__dropdown__content').find('a');
                links.click(function () {
                    if ('undefined' !== typeof $(this).attr('href')) {
                        window.location = $(this).attr('href');
                    }
                });
                subnavLinks.click(function () {
                    window.location = $(this).attr('href');
                });
            };

            if ($(window).width() >= this.mqBreakpoints.xl) {
                goToPage();
            }
            if (/Edge/.test(navigator.userAgent)) {
                goToPage();
            }
        }
    },

    "OpenDropDownsHover": function () {
        if ($('.dropdown-hover-container').length) {
            if ($(window).width() >= this.mqBreakpoints.lg) {
                if (/Edge/.test(navigator.userAgent)) {
                    $('.dropdown-hover-container .dropdown').hover(function () {
                        $(this).stop(true, true).attr('aria-expanded', 'true');
                        $(this).find('.dropdown-menu-list').stop(true, true).delay(200).fadeIn(1);
                        $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeIn(1);
                    }, function () {
                        $(this).find('.dropdown-menu-list').stop(true, true).delay(500).fadeOut(1);
                        $(this).find('.dropdown-menu').stop(true, true).delay(500).fadeOut(1);
                        $(this).stop(true, true).attr('aria-expanded', 'false');
                    });
                } else {
                    $('.dropdown-hover-container .dropdown').hover(function () {
                        $(this).stop(true, true).attr('aria-expanded', 'true');
                        $(this).find('.dropdown-menu-list').stop(true, true).delay(200).fadeIn(200);
                        $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeIn(200);
                    }, function () {
                        $(this).find('.dropdown-menu-list').stop(true, true).delay(500).fadeOut(200);
                        $(this).find('.dropdown-menu').stop(true, true).delay(500).fadeOut(200);
                        $(this).stop(true, true).attr('aria-expanded', 'false');
                    });
                }
            }else{
                $('.dropdown-hover-container .dropdown').off('hover');
            }
        }
    },

    "detectMacOs": function () {
        var mac = /(Mac)/i.test(navigator.platform);
        if (mac) {
            $('body').addClass('--mac-os');
        }
    },


    "mobileSwiper": function () {
        if ($('.mobile-swiper-container').length) {
            $('.mobile-swiper-container').each(function () {
                $(this).find('.swiper-wrapper').removeClass('no-translate');
                var swiperMobile = new Swiper($(this)[0], {
                    loop: false,
                    slidesPerView: 1.25,
                    centeredSlides: true,
                    speed: 1000,
                    spaceBetween: 20,
                    breakpoints: {
                        576: {
                            slidesPerView: 3.25,
                            spaceBetween: 20,
                        },
                        992: {
                            slidesPerView: 'auto',
                            allowSlidePrev: false,
                            allowSlideNext: false,
                            spaceBetween: 0,
                        }
                    },
                    on: {
                        init: function () {
                            this.setTranslate(0);
                        },
                        resize: function () {
                            if ($(this).hasClass('--sm')) {
                                swiperInitBehavior(FondationCancerGeneral.mqBreakpoints.sm);
                            } else {
                                swiperInitBehavior(FondationCancerGeneral.mqBreakpoints.md);
                            }
                        },
                    }
                });

                const swiperInitBehavior = function (breakpoint) {
                    if ($(window).width() <= breakpoint) {
                        swiperMobile.init();
                        swiperMobile.update();
                        swiperMobile.setTranslate(0);
                    } else {
                        swiperMobile.update();
                        swiperMobile.setTranslate(0);
                        swiperMobile.detachEvents();
                        swiperMobile.destroy(true, false);
                        $('.mobile-swiper-container').each(function () {
                            $(this).find('.swiper-wrapper').addClass('no-translate');
                            // $(this).find('.swiper-wrapper').addClass('no-translate').attr('style', '').removeAttr('style');
                        });
                    }
                };

                if ($(this).hasClass('--sm')) {
                    swiperInitBehavior(FondationCancerGeneral.mqBreakpoints.sm);
                } else {
                    swiperInitBehavior(FondationCancerGeneral.mqBreakpoints.md);
                }

            });
        }
    },


    "stickyEl": function () {
        if ($('.js-sticky').length) {
            var sticky;
            if ($(window).width() >= 1291) {
                sticky = new Sticky('.js-sticky');
            }
        }
    },

    "openFirstCollpase": function () {
        if ($('.js-open-first-collapse').length) {
            $('.js-open-first-collapse').each(function () {
                var firstCollapse = $(this).find('.collapse').first();
                firstCollapse.collapse('show');
            })
        }
    },

    "addClassIfIos": function () {
        if (navigator.userAgent.match(/iP(hone|od|ad)/i)) {
            $('body').addClass('browser-ios');
        }
    },

    "onScrollAnimations": function () {
        AOS.refreshHard();
        var animationOffset;
        if ($(window).width() >= this.mqBreakpoints.sm) {
            animationOffset = 50;
        } else {
            animationOffset = 100;
        }
        AOS.init({
            disable: false,
            once: true, // whether animation should happen only once - while scrolling down
            offset: animationOffset, // offset (in px) from the original trigger point
            duration: 1100, // values from 0 to 3000, with step 50ms
        });
        AOS.refreshHard();
    },

    "initAlert": function () {
        let self = this;
        if ($('.js-alert').length) {
            $('header').addClass('header-alert');
            var alertHeight = $('.js-alert').outerHeight();
            $('.message-banner__close-button > button').on('click', function (e) {
                e.preventDefault();
                $('header').removeClass('header-alert');
                // $('.js-alert').css('top', alertHeight * -1).addClass('closed').css('display', 'none');
                $('.js-alert').css('top', alertHeight * -1).addClass('closed');
                self.mobileMenuAlert();
                $('.offcanvas-collapse').css('top', 0);
                $('.navbar-main__collapse-top').css('top', 10);
                $('.navbar-main__dropdown').css('top', 136);
                self.setPaddingTop(alertHeight);
            });
        }
    },

    "moveModalToBody": function () {
        if ($('.js-modal-to-body').length) {
            $('.js-modal-to-body').each(function () {
                $(this).appendTo("body")
            });
        }
    },

    "resetSearchForm": function () {
        if ($('.js-reset-input').length) {
            let input = $('.js-reset-input').find('input[type="text"]');
            if (window.location.href.indexOf("search?") > -1) {
                input.val('');
            }
        }
    },

    "initFiltersDropdown": function () {
        if ($('.js-filter-dropdown').length && !$('.always-show-filters').length) {
            if ($(window).width() <= this.mqBreakpoints.md) {
                var container = $('.js-filter-dropdown');
                container.addClass('dropdown');
            } else {
                container.removeClass('dropdown');
            }
        }
    },

    "changeFilterBtnText": function () {
        if ($('.js-filter-dropdown').length && !$('.always-show-filters').length) {
            var btn = $('.dropdown-toggle span');
            var changeText = function () {
                var checkedInputId = $('.dropdown-menu').find('input:checked').attr("id");
                var checkedInputLabelText = $('.dropdown-menu').find("label[for='" + checkedInputId + "']").text();
                btn.text('');
                btn.text(checkedInputLabelText);
            }
            changeText();
            $('.dropdown-menu input').on('change', function () {
                changeText()
            })
        }
    },

    "mobileDonationButton": function () {
        var $desktopDonationLink = $('.menu--main > .nav-item.last a').attr('href');

        if ('undefined' !== typeof $desktopDonationLink) {
            $('.navbar-main__mobile-top a').attr('href', $desktopDonationLink);
        }
    }
}

export default FondationCancerGeneral;

(function ($) {
    $(document).ready(function () {
        FondationCancerGeneral.addClassOnOpenedMenu();
        FondationCancerGeneral.closeMenuOnResize();
        FondationCancerGeneral.setPaddingTop();
        FondationCancerGeneral.setSameHeight();
        FondationCancerGeneral.addActiveClassOnScroll();
        FondationCancerGeneral.detectMacOs();
        FondationCancerGeneral.OpenDropDownsHover();
        FondationCancerGeneral.fixDropdownLinks();
        FondationCancerGeneral.mobileSwiper();
        FondationCancerGeneral.stickyEl();
        FondationCancerGeneral.openFirstCollpase();
        FondationCancerGeneral.preventScrollOpenedMenu();
        FondationCancerGeneral.addClassIfIos();
        FondationCancerGeneral.onScrollAnimations();
        FondationCancerGeneral.initAlert();
        FondationCancerGeneral.moveModalToBody();
        FondationCancerGeneral.mobileMenuAlert();
        FondationCancerGeneral.resetSearchForm();
        FondationCancerGeneral.changeFilterBtnText();
        FondationCancerGeneral.mobileDonationButton();

        fotoramaInit();

        function fotoramaInit() {
            var $fotoramaItem = $('.fotorama-item');
            if (!$fotoramaItem.length) {
                return;
            }

            $fotoramaItem
                .addClass('fotorama__small')
                .on('fotorama:fullscreenenter', function () {
                    // fotorama.playVideo();
                    $(this).addClass('fotorama__fullscreen');
                    $(this).removeClass('fotorama__small');
                })
                .on('fotorama:fullscreenexit', function () {
                    $(this).removeClass('fotorama__fullscreen');
                    $(this).addClass('fotorama__small');
                })
                .fotorama({arrow: 'always'});
        }

        $(window).resize(function () {
            FondationCancerGeneral.addActiveClassOnScroll();
            FondationCancerGeneral.closeMenuOnResize();
            FondationCancerGeneral.addClassOnOpenedMenu();
            FondationCancerGeneral.setPaddingTop();
            FondationCancerGeneral.setSameHeight();
            FondationCancerGeneral.detectMacOs();
            FondationCancerGeneral.OpenDropDownsHover();
            FondationCancerGeneral.fixDropdownLinks();
            FondationCancerGeneral.stickyEl();
            FondationCancerGeneral.preventScrollOpenedMenu();
            FondationCancerGeneral.onScrollAnimations();
            FondationCancerGeneral.mobileMenuAlert();
            FondationCancerGeneral.changeFilterBtnText();
            if (Map) Map.init();

            if ($(window).width() <= FondationCancerGeneral.mqBreakpoints.md) {
                setTimeout(FondationCancerGeneral.mobileSwiper(), 200);
                //timeout avoid swiper init issues on resize
            }
        });
    });

    $(document).ajaxSuccess(function () {
        FondationCancerGeneral.changeFilterBtnText();
        FondationCancerGeneral.moveModalToBody();

        function fotoramaInit() {
            var $fotoramaItem = $('.fotorama-item');
            if (!$fotoramaItem.length) {
                return;
            }

            $fotoramaItem
                .addClass('fotorama__small')
                .on('fotorama:fullscreenenter', function () {
                    // fotorama.playVideo();
                    $(this).addClass('fotorama__fullscreen');
                    $(this).removeClass('fotorama__small');
                })
                .on('fotorama:fullscreenexit', function () {
                    $(this).removeClass('fotorama__fullscreen');
                    $(this).addClass('fotorama__small');
                })
                .fotorama({arrow: 'always'});
        }

        fotoramaInit();
    });


})(jQuery);

// Fix strange bug where some behaviors are registered but not fired (ex. on views page
window.addEventListener("load", () => {
  Drupal.attachBehaviors();
});
